import React from "react";
import { Box, Typography } from "@mui/material";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import RestaurantMenuRoundedIcon from "@mui/icons-material/RestaurantMenuRounded";
import KingBedRoundedIcon from "@mui/icons-material/KingBedRounded";
import MapRoundedIcon from "@mui/icons-material/MapRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import { LUXURY } from "data/guestLuxuryTheme";

const ICONS = {
  all: GridViewRoundedIcon,
  eat: RestaurantMenuRoundedIcon,
  room: KingBedRoundedIcon,
  stay: MapRoundedIcon,
  help: SupportAgentRoundedIcon,
};

const HubFilterBar = ({ items, value, onChange }) => (
  <Box
    sx={{
      display: "flex",
      gap: 0.7,
      overflowX: "auto",
      mx: -0.25,
      px: 0.25,
      py: 0.15,
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" },
    }}
  >
    {items.map((item) => {
      const Icon = ICONS[item.id] || GridViewRoundedIcon;
      const active = value === item.id;
      return (
        <Box
          key={item.id}
          component="button"
          type="button"
          onClick={() => onChange(item.id)}
          sx={{
            appearance: "none",
            border: active ? `1px solid ${LUXURY.gold}` : `1px solid ${LUXURY.cardBorder}`,
            flex: "0 0 auto",
            minHeight: 38,
            px: 1.3,
            borderRadius: 999,
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.6,
            bgcolor: active ? LUXURY.gold : LUXURY.card,
            color: active ? LUXURY.ink : LUXURY.muted,
            boxShadow: "none",
            transition: "background 0.18s ease, color 0.18s ease",
            WebkitTapHighlightColor: "transparent",
          }}
        >
          <Icon sx={{ fontSize: 15 }} />
          <Typography sx={{ fontSize: "0.74rem", fontWeight: 700, lineHeight: 1, letterSpacing: "-0.01em" }}>
            {item.label}
          </Typography>
        </Box>
      );
    })}
  </Box>
);

export default HubFilterBar;
